export default __webpack_public_path__ + "static/media/creepyForest.9a568399.jpg";